export default __webpack_public_path__ + "static/media/paperclip-small.d1d46515.svg";